<script setup lang="ts">
import { XIcon } from '@clicksign/excalibur';

export type DocumentZoomEmits = {
  (e: 'zoom-reset'): void;
  (e: 'zoom-in'): void;
  (e: 'zoom-out'): void;
};

const emit = defineEmits<DocumentZoomEmits>();
const zoomReset = () => emit('zoom-reset');
const zoomIn = () => emit('zoom-in');
const zoomOut = () => emit('zoom-out');
</script>

<template>
  <div :class="$style.documentZoom">
    <button
      type="button"
      data-testid="documentPreviewZoomInBtn"
      :class="$style.item"
      @click="zoomIn"
    >
      <XIcon icon="plus" />
    </button>

    <button
      type="button"
      data-testid="documentPreviewResetZoomBtn"
      :class="$style.item"
      @click="zoomReset"
    >
      <XIcon icon="search" />
    </button>

    <button
      type="button"
      data-testid="documentPreviewZoomOutBtn"
      :class="$style.item"
      @click="zoomOut"
    >
      <XIcon icon="minus" />
    </button>
  </div>
</template>

<style lang="scss" module>
.documentZoom {
  display: flex;
  flex-direction: column;
  background-color: rgba(62, 62, 62, 0.5);
  border-radius: 0 var(--border-radius-small) var(--border-radius-small) 0;

  > .item {
    padding: var(--space-small-xx);
    text-align: center;
    color: var(--color-neutral-0);
    background-color: transparent;
    border: none;
    cursor: pointer;
  }

  @include breakpoint("medium") {
    top: 120px;
  }
}
</style>
